// Set via the public/config.js file
const { apiURL } = window.APP_CONFIG;

export default apiURL;
